import { DataSource, Layout, Map } from "@mcleod/components";

export abstract class AutogenLayoutViewMovementsMap extends Layout {
    mapPositions: Map;
    sourceViewMovementsMap: DataSource;
}
